var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1894_33685",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#D0D4D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1894_33685)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#D0D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 27.2C18 25.4327 19.4327 24 21.2 24H74.8C76.5673 24 78 25.4327 78 27.2V92.8C78 94.5673 76.5673 96 74.8 96H21.2C19.4327 96 18 94.5673 18 92.8L18 27.2Z",
    fill: "url(#paint0_linear_1894_33685)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6 30C24.7163 30 24 30.7163 24 31.6V32.4C24 33.2837 24.7163 34 25.6 34H65.4C66.2837 34 67 33.2837 67 32.4V31.6C67 30.7163 66.2837 30 65.4 30L25.6 30ZM25.6 37C24.7163 37 24 37.7163 24 38.6V39.4C24 40.2837 24.7163 41 25.6 41H57.4C58.2837 41 59 40.2837 59 39.4V38.6C59 37.7163 58.2837 37 57.4 37H25.6Z",
    fill: "#D0D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6001 67.7659C44.9926 68.3729 44.008 68.3727 43.4008 67.7654L40.4577 64.8223C40.003 64.3676 39.2661 64.3663 38.8098 64.8194C38.3512 65.2748 38.3498 66.0162 38.8069 66.4732L43.4002 71.0665C44.0077 71.674 44.9926 71.674 45.6001 71.0665L57.6775 58.9892C58.1319 58.5348 58.1319 57.7982 57.6775 57.3438C57.2233 56.8896 56.4869 56.8894 56.0325 57.3434L45.6001 67.7659Z",
    fill: "#4D5659",
    stroke: "#4D5659",
    strokeWidth: 1.55556
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1894_33685",
    x1: 48,
    y1: 24,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdered);
export default __webpack_public_path__ + "static/media/ordered.f0bb53ecba42377b9715bc3bb95eb98c.svg";
export { ForwardRef as ReactComponent };